"use strict";

var customerName = require('../fileText/customerName');

var designName = require('../fileText/designName');

var pdf = require('../fileText/pdf');

var variableData = require('../fileText/variableData');

var version = require('../fileText/version');

var envelopeSize = require('./envelopeSize');

var invitationEnvelope = require('./invitationEnvelope');

var guestAndReturnAddressing = require('./guestAndReturnAddressing');

var guestAddressingOnly = require('./guestAddressingOnly');

var returnAddressingOnly = require('./returnAddressingOnly');

var singleOrDouble = require('./singleOrDouble');

var blankEnvelopesOverride = require('./blankEnvelopesOverride');

var innerOrOuter = require('./innerOrOuter');

var namePrinting = require('./namePrinting');

var productTypeForPrinting = require('../fileText/productTypeForPrinting');

var guestAddressingReturnAddressingOrBlank = require('./guestAddressingReturnAddressingOrBlank');

module.exports = {
  productTypeForPrinting: productTypeForPrinting,
  customerName: customerName,
  designName: designName,
  envelopeSize: envelopeSize,
  invitationEnvelope: invitationEnvelope,
  pdf: pdf,
  variableData: variableData,
  version: version,
  guestAddressingReturnAddressingOrBlank: guestAddressingReturnAddressingOrBlank,
  guestAndReturnAddressing: guestAndReturnAddressing,
  guestAddressingOnly: guestAddressingOnly,
  returnAddressingOnly: returnAddressingOnly,
  singleOrDouble: singleOrDouble,
  blankEnvelopesOverride: blankEnvelopesOverride,
  innerOrOuter: innerOrOuter,
  namePrinting: namePrinting
};